<script setup lang="ts">
import { defineProps } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '0'
  },
  name: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    default: '20',
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (value:string) => {
  emit('update:modelValue', value);
};

</script>

<template>
  <div class="flex">
    <div v-if="name!=''" class="bg-metal-900 text-metal-300 flex items-center px-2 rounded-s">{{ name }}</div>
    <div class="bg-metal-900 px-2 flex items-center rounded-e">
      <select
        :value="modelValue"
        @input="updateValue(($event.target as HTMLSelectElement).value)"
        :style="'max-width: ' + props.width + 'rem;'">
        <slot></slot>
      </select>
    </div>
  </div>
</template>

<style scoped lang="scss">
select {
  @apply bg-metal-800 border border-metal-700 hover:border-metal-600 focus:outline-none text-metal-300 rounded focus:ring-metal-700 focus:border-metal-500 px-2 py-1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1rem;
  padding-right: 2rem;
}
</style>